import React, { useEffect, useContext, useState, useRef } from 'react'
import VideoJS from '../../components/player/videoJS'
// import LiveIcon from '../../assets/live-icon-new.png'
import { isEmpty } from 'lodash'
import { getAdUrl } from '../../utils/helper'
import { AppContext } from '../../context/app'
import useAdvertisementHook from './advertisementHook'
import SoundIcon from '../../assets/mute-icon-new.svg'
import MuteIcon from '../../assets/unmute-icon-new.svg'

const AdhocAdPlayer = ({ adInfo, isMuted = true, volumeLevel = 1, loop = true, onEnded }) => {
  //   const adhocVideoRef = React.useRef(null)
  const adhocPlayerRef = useRef(null)
  const { getStyleValue, handleRedirect, positionConfig } = useAdvertisementHook()
  const { accountObj } = useContext(AppContext)
  const [toggleMute, setToggleMute] = useState(isMuted)

  useEffect(() => {
    if (!isEmpty(adInfo)) {
      changeSource(adInfo)
    }
  }, [adInfo])

  useEffect(() => {
    // Update muted state when isMuted prop changes
    if (adhocPlayerRef.current) {
      adhocPlayerRef.current.muted(isMuted)
      setToggleMute(isMuted)
    }
  }, [isMuted])

  useEffect(() => {
    // Update volume when volumeLevel prop changes
    if (adhocPlayerRef.current) {
      adhocPlayerRef.current.volume(volumeLevel)
    }
  }, [volumeLevel])

  const videoJsOptions = {
    // lookup the options in the docs for more options
    autoplay: true,
    controls: false,
    responsive: true,
    muted: isMuted,
    loadingSpinner: true,
    liveui: true,
    loop,
    // preload: "metadata",
    // fluid: true,
    // aspectRatio: "16:9",
    // fill: true,
    suppressNotSupportedError: true,
    sources: [
      {
        src: getAdUrl(accountObj?.cf_domain_name, adInfo?.source_asset_id?._id, '480'),
        type: 'application/x-mpegURL',
      },
    ],
  }

  const handlePlayerReady = (player) => {
    adhocPlayerRef.current = player

    // you can handle player events here
    player.on('ready', () => {
      console.log('adhoc player is ready')
      // Set the initial muted state and volume from props
      player.muted(isMuted)
      player.volume(volumeLevel)
      setToggleMute(isMuted)
    })

    player.on('waiting', () => {
      console.log('adhoc player is waiting')
    })

    player.on('loadedmetadata', () => {
      console.log('adhoc player is loadedmetadata')
    })

    player.on('pause', () => {
      console.log('adhoc player is pause')
      // setIsPlaying(false)

      // player.muted(false)
    })

    player.on('play', () => {
      console.log('adhoc player is play')

      //   if (player?.muted()) {
      //     player.muted(false)
      //   }
      //   player.muted(false)
    })

    player.on('dispose', () => {
      console.log('adhoc player is dispose')
    })

    player.on('ended', () => {
      onEnded && onEnded()
    })
  }

  const changeSource = (adInfo) => {
    if (!adhocPlayerRef.current) {
      return
    }

    let videoElm = adhocPlayerRef.current

    if (!videoElm.paused) {
      videoElm.pause()
    }
    videoElm.src([
      {
        src: getAdUrl(accountObj?.cf_domain_name, adInfo?.source_asset_id?._id, '480'),
        type: 'application/x-mpegURL',
      },
    ])

    videoElm.load()
    videoElm.play()

    // setToggleMute(true)
    // adhocPlayerRef.current.muted(true)
    // adhocPlayerRef.current.autoplay(true)
  }

  const changePlayerOptions = (status) => {
    // you can update the player through the Video.js player instance
    if (!adhocPlayerRef.current) {
      return
    }

    // [update player through instance's api]
    adhocPlayerRef.current.muted(status)
    setToggleMute(status)
  }

  return (
    <div style={{}} className="relative h-full w-full">
      {/* <div data-vjs-player="">
        <video
          ref={adhocVideoRef}
          className="video-js vjs-fill vjs-big-play-centered object-cove vjs-theme-fantasy"
        />
      </div> */}
      <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />

      <div className="w-full h-full absolute top-0 left-0 z-20">
        <div className="w-full h-full flex relative flex-col pt-4 pb-10 pl-7 pr-7">
          <div
            className={`flex  absolute bottom-0 pt-4 pb-6 pl-7 pr-7 right-0 z-10 text-white`}
            style={{ alignItems: 'center' }}
          >
            <div>
              {toggleMute ? (
                <div
                  className={`w-8 h-8 cursor-pointer `}
                  onClick={() => changePlayerOptions(false)}
                >
                  <img src={MuteIcon} className="w-full h-full" alt="MuteIcon" />
                </div>
              ) : (
                <div
                  className={`w-8 h-8 cursor-pointer `}
                  onClick={() => changePlayerOptions(true)}
                >
                  <img src={SoundIcon} className="w-full h-full" alt="SoundIcon" />
                </div>
              )}
            </div>
          </div>
          {adInfo?.button?.is_enabled && !adInfo?.button?.position.includes('BOTTOM') && (
            <div className={`w-full h-full flex ${positionConfig[adInfo?.button?.position]}`}>
              <button
                style={{
                  fontSize: '12px',
                  backgroundColor: getStyleValue('button_background', 'color', '#ffd91d'),
                  color: getStyleValue('button_text', 'color', '#000'),
                  fontFamily: getStyleValue('button_text', 'font', ''),
                  textAlign: getStyleValue('button_text', 'alignment', ''),
                  height: '34px',
                }}
                className={`border rounded-full px-4 ${getStyleValue(
                  'button_text',
                  'font_format',
                  '',
                )}`}
                onClick={() => handleRedirect(adInfo?.button?.link)}
              >
                {adInfo?.button?.text}
              </button>
            </div>
          )}
          <div
            style={{ marginTop: 'auto', fontSize: '12px' }}
            className="flex justify-between items-center relative"
          >
            {adInfo?.button?.is_enabled && adInfo?.button?.position.includes('BOTTOM') && (
              <button
                style={{
                  fontSize: '12px',
                  background: '#ffd91d',
                  height: '34px',
                  zIndex: 20,
                  color: '#000',
                  ...positionConfig[adInfo?.button?.position],
                  right: adInfo?.button?.position === 'BOTTOM_RIGHT' ? '40px' : '',
                }}
                className={`border rounded-full px-4 absolute w-auto `}
                onClick={() => handleRedirect(adInfo?.button?.link)}
              >
                {adInfo?.button?.text}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdhocAdPlayer
